import { render, staticRenderFns } from "./CalendarDoctor.vue?vue&type=template&id=d88706c8&"
import script from "./CalendarDoctor.vue?vue&type=script&lang=ts&"
export * from "./CalendarDoctor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports